import 'es7-object-polyfill'

if (!String.prototype.endsWith) {
  // eslint-disable-next-line no-extend-native
  String.prototype.endsWith = function (search, thisLength) {
    if (thisLength === undefined || thisLength > this.length) {
      thisLength = this.length
    }
    return this.substring(thisLength - search.length, thisLength) === search
  }
}

;(function () {
  if (typeof window.CustomEvent === 'function') return false

  function CustomEvent(event: string, params: CustomEventInit) {
    params = params || { bubbles: false, cancelable: false, detail: null }
    const evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(
      event,
      params.bubbles!,
      params.cancelable!,
      params.detail!
    )
    return evt
  }

  // @ts-ignore
  window.CustomEvent = CustomEvent
})()

if (!Object.entries) {
  Object.entries = function (obj: Record<string | number, any>) {
    const ownProps = Object.keys(obj)
    let i = ownProps.length
    const resArray = new Array(i) // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]]
    }
    return resArray
  }
}
